var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorAngel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.70667 416.98666",
    height: 416.98666,
    width: 635.70667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,416.98667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2564.15,2471.56 c -0.07,0.21 -0.14,0.43 -0.21,0.64 -6.78,19.32 -1.65,40.17 12.5,54.96 10.82,11.3 16.83,23.11 16.83,34.66 0,46.97 -95.89,99.47 -224.25,99.47 -128.34,0 -224.23,-52.5 -224.23,-99.47 0,-12.48 7.03,-25.28 19.56,-37.39 12.76,-12.36 17.88,-30.57 11.7,-47.23 l -0.33,-0.88 c -6.44,-17.34 -28.04,-23.46 -42.55,-11.99 -34.35,27.16 -54.5,60.7 -54.5,97.49 0,92.82 127.55,165.53 290.35,165.53 162.81,0 290.37,-72.71 290.37,-165.53 0,-38.3 -21.81,-73.06 -58.74,-100.77 -12.7,-9.53 -31.28,-4.49 -36.5,10.51 z m 55.81,625.73 c -518.17,134.03 -1050.58,-191.63 -1189.17,-727.38 -116.09,-448.8 81.02,-902.64 452.66,-1116.94 25.35,-14.6 57.58,-0.93 63.89,27.64 27.89,126.23 100.75,435.33 175.62,581.62 -56.68,0.06 -163.47,2.03 -189.68,41.37 -28.74,43.08 23.26,130.98 -25.21,159.7 -37.58,22.26 -105.93,21.54 -107.27,67.94 -1.42,49.09 24.69,158.25 -41.73,163.65 -39.53,3.19 -102.34,140.02 -50.27,156.18 74.77,38.76 409.84,-191.39 559.36,-298.81 14.58,21.25 26.63,44.1 18.86,53.46 -16.15,19.53 -91.3,1.65 -80.71,167.66 -5.16,175.36 111.36,193.35 160.3,193.28 0.77,0.01 1.59,0.01 2.41,0.02 0.83,-0.01 1.66,-0.01 2.44,-0.02 48.93,0.07 165.46,-17.92 160.28,-193.28 10.6,-166.01 -64.54,-148.13 -80.69,-167.66 -7.77,-9.36 4.27,-32.21 18.84,-53.46 149.54,107.42 484.6,337.57 559.37,298.81 52.07,-16.16 -10.73,-152.99 -50.26,-156.18 -66.43,-5.4 -40.31,-114.56 -41.73,-163.65 -1.36,-46.4 -69.69,-45.68 -107.29,-67.94 -48.47,-28.72 3.53,-116.62 -25.19,-159.7 -26.22,-39.34 -133.01,-41.31 -189.69,-41.37 79.32,-154.96 156.64,-415.74 180.46,-560.95 4.85,-29.62 38.16,-44.56 63.69,-28.76 213.13,131.82 379.19,345.91 448.02,611.99 138.59,535.76 -169.13,1078.73 -687.31,1212.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 353.816,214.18 -65.105,141.359 h -0.848 L 223.609,214.18 Z M 1.72656,30.8398 269.863,607.41 c 2.571,5.141 8.575,9.418 14.563,9.418 H 293 c 5.984,0 11.992,-4.277 14.559,-9.418 L 575.699,30.8398 C 580.855,19.7109 574,8.57031 561.141,8.57031 h -95.094 c -15.414,0 -22.27,5.14059 -29.977,21.41799 L 405.227,97.6602 H 172.199 L 141.359,29.1406 C 137.07,18.8398 127.648,8.57031 110.516,8.57031 H 16.2852 C 3.42578,8.57031 -3.42969,19.7109 1.72656,30.8398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 611.633,601.41 c 0,8.57 7.703,15.418 16.265,15.418 h 21.415 L 991.148,287.859 h 0.848 v 304.129 c 0,8.563 6.859,16.282 16.284,16.282 h 102.8 c 8.57,0 16.28,-7.719 16.28,-16.282 V 15.4297 C 1127.36,6.85156 1119.65,0 1111.08,0 h -13.71 c -2.57,0 -9.42,2.55859 -11.12,4.28125 L 747.848,344.398 H 746.98 V 24.8516 c 0,-8.5703 -6.859,-16.28129 -16.281,-16.28129 H 628.766 c -8.575,0 -16.286,7.71099 -16.286,16.28129 L 611.633,601.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1496.52,615.98 c 71.96,0 150.78,-30 209.04,-80.531 7.71,-6.008 8.56,-16.277 1.7,-23.14 l -67.67,-71.957 c -6.85,-5.993 -16.28,-5.993 -23.13,-0.852 -32.55,29.969 -70.25,41.109 -112.23,41.109 -93.38,0 -168.77,-78.808 -168.77,-173.058 0,-93.371 76.24,-170.469 169.63,-170.469 24.84,0 50.55,3.406 76.25,13.707 v 49.68 h -53.98 c -9.42,0 -16.27,6.851 -16.27,15.422 v 84.828 c 0,9.402 6.85,16.261 16.27,16.261 h 172.2 c 8.57,0 15.43,-7.71 15.43,-16.261 l 0.85,-230.4573 c 0,-4.2929 -3.42,-11.1406 -6.86,-13.7109 0,0 -88.24,-55.679706 -212.46,-55.679706 -170.49,0 -307.55,135.358906 -307.55,306.679906 0,171.34 137.06,308.429 307.55,308.429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1799.72,591.988 c 0,8.563 6.86,16.282 16.29,16.282 h 354.67 c 9.41,0 16.27,-7.719 16.27,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.27,-16.281 H 1933.37 V 376.102 h 195.33 c 8.57,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.71,-16.293 -16.28,-16.293 H 1933.37 V 134.512 h 237.31 c 9.41,0 16.27,-7.711 16.27,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.27,-16.28129 h -354.67 c -9.43,0 -16.29,7.71099 -16.29,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2268.3,591.988 c 0,8.563 6.85,16.282 16.28,16.282 h 101.95 c 8.56,0 16.26,-7.719 16.26,-16.282 V 134.512 h 203.91 c 9.42,0 16.28,-7.711 16.28,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.28,-16.28129 h -322.12 c -9.43,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2905.6,482.328 h -122.5 c -9.43,0 -16.28,7.711 -16.28,16.281 v 93.379 c 0,8.563 6.85,16.282 16.28,16.282 h 380.36 c 9.43,0 16.29,-7.719 16.29,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.29,-16.281 h -122.5 V 24.8516 c 0,-8.5703 -7.71,-16.28129 -16.28,-16.28129 h -102.8 c -8.58,0 -16.28,7.71099 -16.28,16.28129 V 482.328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3493.25,352.109 c 35.12,0 65.11,32.551 65.11,68.539 0,35.981 -29.99,65.102 -65.11,65.102 h -126.8 V 352.109 Z m -261.3,239.879 c 0,8.563 6.86,16.282 16.28,16.282 h 256.15 c 102.8,0 186.77,-83.098 186.77,-185.051 0,-78.821 -52.26,-142.219 -126.8,-172.199 L 3681.73,33.4102 c 5.99,-11.1289 0,-24.83989 -14.58,-24.83989 h -113.93 c -6.85,0 -11.99,4.28909 -13.71,7.71099 L 3425.57,243.301 h -59.12 V 24.8516 c 0,-8.5703 -7.71,-16.28129 -16.26,-16.28129 h -101.96 c -9.42,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3730.5,591.988 c 0,8.563 6.85,16.282 16.29,16.282 h 354.68 c 9.4,0 16.26,-7.719 16.26,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.26,-16.281 H 3864.15 V 376.102 h 195.32 c 8.58,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.7,-16.293 -16.28,-16.293 H 3864.15 V 134.512 h 237.32 c 9.4,0 16.26,-7.711 16.26,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.26,-16.28129 h -354.68 c -9.44,0 -16.29,7.71099 -16.29,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#211d1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4199.06,591.988 c 0,8.563 6.86,16.282 16.28,16.282 h 354.68 c 9.41,0 16.26,-7.719 16.26,-16.282 v -93.379 c 0,-8.57 -6.85,-16.281 -16.26,-16.281 H 4332.71 V 376.102 h 195.33 c 8.55,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.73,-16.293 -16.28,-16.293 H 4332.71 V 134.512 h 237.31 c 9.41,0 16.26,-7.711 16.26,-16.282 V 24.8516 c 0,-8.5703 -6.85,-16.28129 -16.26,-16.28129 h -354.68 c -9.42,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 353.816,214.18 -65.105,141.359 h -0.848 L 223.609,214.18 Z M 1.72656,30.8398 269.863,607.41 c 2.571,5.141 8.575,9.418 14.563,9.418 H 293 c 5.984,0 11.992,-4.277 14.559,-9.418 L 575.699,30.8398 C 580.855,19.7109 574,8.57031 561.141,8.57031 h -95.094 c -15.414,0 -22.27,5.14059 -29.977,21.41799 L 405.227,97.6602 H 172.199 L 141.359,29.1406 C 137.07,18.8398 127.648,8.57031 110.516,8.57031 H 16.2852 C 3.42578,8.57031 -3.42969,19.7109 1.72656,30.8398"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 611.633,601.41 c 0,8.57 7.703,15.418 16.265,15.418 h 21.415 L 991.148,287.859 h 0.848 v 304.129 c 0,8.563 6.859,16.282 16.284,16.282 h 102.8 c 8.57,0 16.28,-7.719 16.28,-16.282 V 15.4297 C 1127.36,6.85156 1119.65,0 1111.08,0 h -13.71 c -2.57,0 -9.42,2.55859 -11.12,4.28125 L 747.848,344.398 H 746.98 V 24.8516 c 0,-8.5703 -6.859,-16.28129 -16.281,-16.28129 H 628.766 c -8.575,0 -16.286,7.71099 -16.286,16.28129 L 611.633,601.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1496.52,615.98 c 71.96,0 150.78,-30 209.04,-80.531 7.71,-6.008 8.56,-16.277 1.7,-23.14 l -67.67,-71.957 c -6.85,-5.993 -16.28,-5.993 -23.13,-0.852 -32.55,29.969 -70.25,41.109 -112.23,41.109 -93.38,0 -168.77,-78.808 -168.77,-173.058 0,-93.371 76.24,-170.469 169.63,-170.469 24.84,0 50.55,3.406 76.25,13.707 v 49.68 h -53.98 c -9.42,0 -16.27,6.851 -16.27,15.422 v 84.828 c 0,9.402 6.85,16.261 16.27,16.261 h 172.2 c 8.57,0 15.43,-7.71 15.43,-16.261 l 0.85,-230.4573 c 0,-4.2929 -3.42,-11.1406 -6.86,-13.7109 0,0 -88.24,-55.679706 -212.46,-55.679706 -170.49,0 -307.55,135.358906 -307.55,306.679906 0,171.34 137.06,308.429 307.55,308.429"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1799.72,591.988 c 0,8.563 6.86,16.282 16.29,16.282 h 354.67 c 9.41,0 16.27,-7.719 16.27,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.27,-16.281 H 1933.37 V 376.102 h 195.33 c 8.57,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.71,-16.293 -16.28,-16.293 H 1933.37 V 134.512 h 237.31 c 9.41,0 16.27,-7.711 16.27,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.27,-16.28129 h -354.67 c -9.43,0 -16.29,7.71099 -16.29,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2268.3,591.988 c 0,8.563 6.85,16.282 16.28,16.282 h 101.95 c 8.56,0 16.26,-7.719 16.26,-16.282 V 134.512 h 203.91 c 9.42,0 16.28,-7.711 16.28,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.28,-16.28129 h -322.12 c -9.43,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2905.6,482.328 h -122.5 c -9.43,0 -16.28,7.711 -16.28,16.281 v 93.379 c 0,8.563 6.85,16.282 16.28,16.282 h 380.36 c 9.43,0 16.29,-7.719 16.29,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.29,-16.281 h -122.5 V 24.8516 c 0,-8.5703 -7.71,-16.28129 -16.28,-16.28129 h -102.8 c -8.58,0 -16.28,7.71099 -16.28,16.28129 V 482.328"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3493.25,352.109 c 35.12,0 65.11,32.551 65.11,68.539 0,35.981 -29.99,65.102 -65.11,65.102 h -126.8 V 352.109 Z m -261.3,239.879 c 0,8.563 6.86,16.282 16.28,16.282 h 256.15 c 102.8,0 186.77,-83.098 186.77,-185.051 0,-78.821 -52.26,-142.219 -126.8,-172.199 L 3681.73,33.4102 c 5.99,-11.1289 0,-24.83989 -14.58,-24.83989 h -113.93 c -6.85,0 -11.99,4.28909 -13.71,7.71099 L 3425.57,243.301 h -59.12 V 24.8516 c 0,-8.5703 -7.71,-16.28129 -16.26,-16.28129 h -101.96 c -9.42,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3730.5,591.988 c 0,8.563 6.85,16.282 16.29,16.282 h 354.68 c 9.4,0 16.26,-7.719 16.26,-16.282 v -93.379 c 0,-8.57 -6.86,-16.281 -16.26,-16.281 H 3864.15 V 376.102 h 195.32 c 8.58,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.7,-16.293 -16.28,-16.293 H 3864.15 V 134.512 h 237.32 c 9.4,0 16.26,-7.711 16.26,-16.282 V 24.8516 c 0,-8.5703 -6.86,-16.28129 -16.26,-16.28129 h -354.68 c -9.44,0 -16.29,7.71099 -16.29,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#d71d29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4199.06,591.988 c 0,8.563 6.86,16.282 16.28,16.282 h 354.68 c 9.41,0 16.26,-7.719 16.26,-16.282 v -93.379 c 0,-8.57 -6.85,-16.281 -16.26,-16.281 H 4332.71 V 376.102 h 195.33 c 8.55,0 16.28,-7.723 16.28,-16.293 v -93.368 c 0,-9.429 -7.73,-16.293 -16.28,-16.293 H 4332.71 V 134.512 h 237.31 c 9.41,0 16.26,-7.711 16.26,-16.282 V 24.8516 c 0,-8.5703 -6.85,-16.28129 -16.26,-16.28129 h -354.68 c -9.42,0 -16.28,7.71099 -16.28,16.28129 V 591.988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 366.902,854.039 c 42.547,0 78.582,35.18 78.582,79.02 0,42.543 -36.035,76.411 -79.019,76.411 H 289.191 V 854.039 Z m -98.117,170.181 c 0,3.05 2.602,5.66 5.645,5.66 h 93.34 c 53.839,0 98.121,-43.86 98.121,-97.259 0,-54.262 -44.282,-98.543 -97.688,-98.543 H 289.191 V 731.621 c 0,-3.051 -2.609,-5.652 -6.949,-5.652 h -7.812 c -3.043,0 -5.645,2.601 -5.645,5.652 v 292.599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 636.074,861.422 c 41.68,0 76.844,32.558 76.844,75.547 0,41.242 -35.164,72.931 -77.277,72.931 H 544.469 V 861.422 Z M 523.629,1024.22 c 0,3.05 2.168,5.66 5.644,5.66 h 107.668 c 52.965,0 96.817,-39.95 96.817,-92.911 0,-43.848 -30.395,-79.008 -71.633,-90.739 l 63.383,-112.441 c 2.168,-3.469 1.305,-7.82 -3.039,-7.82 h -13.457 c -3.039,0 -4.778,1.301 -6.082,3.91 l -62.95,113.742 c -5.644,-0.43 -10.417,-0.43 -16.062,-0.43 h -79.883 v -111.57 c 0,-3.051 -2.609,-5.652 -6.945,-5.652 h -7.817 c -3.043,0 -5.644,2.601 -5.644,5.652 v 292.599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 805.824,1024.22 c 0,3.05 2.606,5.66 5.649,5.66 h 9.55 c 3.036,0 5.645,-2.61 5.645,-5.66 V 731.621 c 0,-3.48 -3.039,-5.652 -6.082,-5.652 h -9.113 c -3.043,0 -5.649,2.601 -5.649,5.652 v 292.599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 904.813,766.34 3.906,5.219 c 3.035,3.472 6.078,4.773 9.551,1.742 4.339,-3.922 36.468,-33.442 80.316,-33.442 39.504,0 72.934,26.481 72.934,58.172 0,38.649 -31.69,56.008 -84.223,73.809 -50.363,17.801 -83.789,35.609 -83.789,85.531 0,32.559 26.051,76.849 93.773,76.849 42.979,0 74.669,-22.14 74.669,-22.14 1.74,-1.31 4.78,-4.35 1.74,-9.12 -1.3,-1.74 -2.6,-3.909 -3.47,-5.651 -2.61,-3.469 -5.21,-4.77 -9.55,-2.168 -1.3,0.871 -30.39,20.399 -63.818,20.399 -53.403,0 -73.375,-32.989 -73.375,-57.731 0,-36.911 28.222,-52.969 72.066,-67.297 59.487,-20.41 97.247,-41.242 97.247,-91.614 0,-43.41 -44.71,-77.269 -94.638,-77.269 -51.668,0 -86.398,30.391 -92.039,35.601 -2.605,2.168 -4.777,4.34 -1.3,9.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1293.38,740.738 c 75.97,0 137.62,60.774 137.62,136.75 0,75.973 -61.65,137.622 -137.62,137.622 -75.98,0 -137.2,-61.649 -137.2,-137.622 0,-75.976 61.22,-136.75 137.2,-136.75 z m 0,293.482 c 87.26,0 156.72,-69.9 156.72,-156.732 0,-87.269 -69.46,-155.859 -156.72,-155.859 -86.84,0 -156.3,68.59 -156.3,155.859 0,86.832 69.46,156.732 156.3,156.732"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1516.09,1028.57 c 0,3.48 3.04,5.65 6.51,5.65 h 7.38 l 208.39,-271.341 c 0.44,0 0.44,0 0.44,0 v 261.341 c 0,3.05 2.61,5.66 5.64,5.66 h 8.69 c 3.03,0 5.64,-2.61 5.64,-5.66 V 727.27 c 0,-3.899 -3.47,-5.641 -6.95,-5.641 h -5.64 c -0.44,0 -3.91,1.312 -210.13,273.949 h -0.43 V 731.621 c 0,-3.051 -2.61,-5.652 -5.65,-5.652 h -8.25 c -3.03,0 -5.64,2.601 -5.64,5.652 v 296.949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1932.54,1019.88 c 0,3.04 2.6,5.64 5.64,5.64 h 174.1 c 3.03,0 5.64,-2.6 5.64,-5.64 v -7.38 c 0,-3.04 -2.61,-5.64 -5.64,-5.64 h -158.9 V 874.879 H 2091 c 3.04,0 5.65,-2.609 5.65,-5.649 0,-4.769 0.87,-12.582 -5.65,-12.582 h -137.62 l -0.43,-129.378 c 0,-3.051 -2.61,-5.641 -6.95,-5.641 h -7.82 c -3.04,0 -5.64,2.59 -5.64,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2181.3,1019.88 c 0,3.04 2.61,5.64 5.65,5.64 h 174.1 c 3.03,0 5.64,-2.6 5.64,-5.64 v -7.38 c 0,-3.04 -2.61,-5.64 -5.64,-5.64 H 2202.14 V 887.039 h 137.63 c 3.04,0 5.65,-2.609 5.65,-5.648 v -7.379 c 0,-3.043 -2.61,-5.641 -5.65,-5.641 H 2202.14 V 739.859 h 158.91 c 3.03,0 5.64,-2.609 5.64,-5.64 v -6.949 c 0,-3.051 -2.61,-5.641 -5.64,-5.641 h -174.1 c -3.04,0 -5.65,2.59 -5.65,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2440.93,1019.88 c 0,3.04 2.6,5.64 5.63,5.64 h 9.56 c 2.6,0 5.21,-2.6 5.21,-5.64 V 739.859 h 138.5 c 5.2,0 5.64,-2.609 5.64,-5.64 v -7.828 c 0,-3.032 -2.61,-4.762 -5.64,-4.762 h -153.27 c -3.03,0 -5.63,2.59 -5.63,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2661.05,1019.88 c 0,3.04 2.59,5.64 5.63,5.64 h 9.56 c 2.6,0 5.21,-2.6 5.21,-5.64 V 739.859 h 138.49 c 5.21,0 5.65,-2.609 5.65,-5.64 v -7.828 c 0,-3.032 -2.61,-4.762 -5.65,-4.762 h -153.26 c -3.04,0 -5.63,2.59 -5.63,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2994.47,740.73 c 75.98,0 137.63,60.782 137.63,136.758 0,75.973 -61.65,137.622 -137.63,137.622 -75.97,0 -137.18,-61.649 -137.18,-137.622 0,-75.976 61.21,-136.758 137.18,-136.758 z m 0,293.48 c 87.27,0 156.73,-69.901 156.73,-156.722 0,-87.269 -69.46,-155.859 -156.73,-155.859 -86.82,0 -156.29,68.59 -156.29,155.859 0,86.821 69.47,156.722 156.29,156.722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3179.85,1024.22 c -0.86,4.35 0.87,5.65 4.78,5.65 h 10.42 c 2.61,0 4.78,-2.17 5.21,-4.78 l 72.93,-254.41 c 0.44,0 0.87,0 0.87,0 l 76.42,259.63 c 0.87,2.6 3.91,3.9 6.5,3.9 h 0.88 c 2.6,0 5.64,-1.3 6.51,-3.9 l 76.84,-259.63 c 0,0 0.44,0 0.87,0 l 72.51,254.41 c 0.43,2.61 2.6,4.78 5.21,4.78 h 10.42 c 3.9,0 5.64,-1.3 4.77,-5.65 l -85.97,-299.56 c -0.43,-1.73 -2.16,-3.031 -3.89,-3.031 h -4.79 c -2.16,0 -3.46,0.871 -4.33,3.031 l -78.15,264.399 h -0.88 L 3278.84,724.66 c -0.86,-2.16 -2.17,-3.031 -4.34,-3.031 h -4.78 c -1.73,0 -3.47,1.301 -3.9,3.031 l -85.97,299.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3579.71,766.34 3.9,5.211 c 3.04,3.48 6.08,4.769 9.56,1.738 4.34,-3.91 36.46,-33.43 80.32,-33.43 39.5,0 72.93,26.481 72.93,58.172 0,38.649 -31.69,56.008 -84.22,73.809 -50.36,17.801 -83.79,35.609 -83.79,85.531 0,32.559 26.04,76.839 93.77,76.839 42.99,0 74.68,-22.14 74.68,-22.14 1.73,-1.3 4.77,-4.34 1.73,-9.11 -1.29,-1.74 -2.6,-3.909 -3.47,-5.651 -2.61,-3.477 -5.21,-4.77 -9.55,-2.168 -1.3,0.859 -30.39,20.399 -63.82,20.399 -53.4,0 -73.38,-32.989 -73.38,-57.739 0,-36.903 28.22,-52.961 72.08,-67.301 59.47,-20.398 97.25,-41.238 97.25,-91.602 0,-43.418 -44.72,-77.269 -94.65,-77.269 -51.66,0 -86.4,30.391 -92.04,35.59 -2.6,2.179 -4.78,4.351 -1.3,9.121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3833.69,1019.88 c 0,3.04 2.6,5.64 5.64,5.64 h 9.12 c 3.48,0 5.64,-2.6 5.64,-5.64 V 886.602 h 194.93 v 133.278 c 0,3.04 2.61,5.64 5.65,5.64 h 9.12 c 3.47,0 5.64,-2.6 5.64,-5.64 V 727.27 c 0,-3.051 -2.17,-5.641 -5.64,-5.641 h -9.12 c -3.04,0 -5.65,2.59 -5.65,5.641 V 868.371 H 3854.09 V 727.27 c 0,-3.051 -2.16,-5.641 -5.64,-5.641 h -9.12 c -3.04,0 -5.64,2.59 -5.64,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4161.47,1019.88 c 0,3.04 2.6,5.64 5.64,5.64 h 9.55 c 3.04,0 5.65,-2.6 5.65,-5.64 V 727.27 c 0,-3.469 -3.05,-5.641 -6.09,-5.641 h -9.11 c -3.04,0 -5.64,2.59 -5.64,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4370.28,849.691 c 42.55,0 78.59,35.168 78.59,79.028 0,42.543 -36.04,76.401 -79.02,76.401 h -77.27 V 849.691 Z m -98.11,170.189 c 0,3.04 2.61,5.64 5.64,5.64 h 93.34 c 53.84,0 98.13,-43.84 98.13,-97.239 0,-54.269 -44.29,-98.562 -97.69,-98.562 h -79.01 V 727.27 c 0,-3.051 -2.61,-5.641 -6.95,-5.641 h -7.82 c -3.03,0 -5.64,2.59 -5.64,5.641 v 292.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#7a7c81",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4693.2,21.2617 10.92,57.9492 c 0.41,1.668 2.09,3.1407 3.99,3.1407 h 0.84 c 1.26,0 3.14,-1.25 3.57,-2.3008 l 17.64,-41.7813 18.04,41.7813 c 0.43,1.0508 2.32,2.3008 3.58,2.3008 h 0.84 c 1.68,0 3.57,-1.4727 3.98,-3.1407 l 11.14,-58.1718 c 0.42,-2.5196 -1.47,-4.6094 -3.99,-4.6094 h -5.47 c -1.88,0 -3.56,1.6797 -3.98,3.5703 l -5.88,30.4414 -14.28,-32.7617 c -0.42,-1.0391 -2.1,-1.8789 -3.36,-1.8789 h -1.26 c -1.04,0 -2.94,0.8398 -3.56,2.0976 l -13.65,32.543 -6.3,-30.6523 c -0.21,-1.6797 -2.32,-3.3594 -4,-3.3594 h -4.82 c -2.74,0 -4.42,2.3086 -3.99,4.832 z m -38.42,-0.8398 v 47.8672 h -14.08 c -2.09,0 -3.98,1.6797 -3.98,3.9804 v 5.0391 c 0,2.1133 1.89,3.9922 3.98,3.9922 h 41.59 c 2.3,0 3.98,-1.8789 3.98,-3.9922 v -5.0391 c 0,-2.3007 -1.68,-3.9804 -3.98,-3.9804 h -14.08 V 20.4219 c 0,-2.1016 -1.88,-3.9922 -3.99,-3.9922 h -5.45 c -2.31,0 -3.99,1.8906 -3.99,3.9922"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAngel);
export default __webpack_public_path__ + "static/media/errorAngel.6bfdfe53aec51b92aec95be6bda660fa.svg";
export { ForwardRef as ReactComponent };